import Container from '@mui/material/Container';
import {
  isRouteErrorResponse,
  Link as RouterLink,
  useRouteError,
} from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import { StatusPage } from '@/features/errors/StatusPage';

import { ROUTES } from '../routes';

/**
 * Shown when a route throws, or an address outside the portal frame matches
 * nothing. An unknown address inside the frame gets the not-found page there
 * instead, with the navigation still around it.
 *
 * Its own main landmark, because it renders where the layout itself may be
 * what failed.
 */
export function ErrorRoute() {
  const error = useRouteError();

  const title = isRouteErrorResponse(error)
    ? `${String(error.status)} ${error.statusText}`
    : 'Something went wrong';

  const detail = isRouteErrorResponse(error)
    ? 'That page does not exist.'
    : error instanceof Error
      ? error.message
      : 'An unexpected error occurred.';

  return (
    <Container component="main" id="main" maxWidth="sm" sx={{ py: 8 }}>
      <StatusPage
        title={title}
        documentTitle={title}
        action={
          <Button component={RouterLink} to={ROUTES.home} variant="secondary">
            Back to the start
          </Button>
        }
      >
        {detail}
      </StatusPage>
    </Container>
  );
}
